import type { TMessages } from '@/types/TMessages'

export const messages = { noProducts: 'Оставьте заявку' } satisfies TMessages
